import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b6bx4chhb1: FaireBrandEntity = {
  token: "b_b6bx4chhb1",
  type: "brand",
  name: "Zatik Naturals",
  avatarUrl:
    "https://cdn.faire.com/fastly/bd6f7659af6a33a213a30040ae5d2f11303dcdab37f45cef40e0e6c44c5494bc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5bea367ceba9f990f8e75332f8027b24d6e22957849a35a6120bd20488eebaea.png",
  logoUrl:
    "https://cdn.faire.com/fastly/bd6f7659af6a33a213a30040ae5d2f11303dcdab37f45cef40e0e6c44c5494bc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5bea367ceba9f990f8e75332f8027b24d6e22957849a35a6120bd20488eebaea.png",
  location: "Burbank, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 6,
  isTopShop: true,
  isInsider: true,
  description:
    "Zatik Naturals combines the powerful synergy of bioactive-rich and Certified Organic extracts for formulas that wow.\n\n \n\nAll of Zatik Naturals’ products are handmade in Glendale, using fresh raw botanicals cultivated on USDA certified organic farms without the use of GMOs. The Zatik facility undergoes annual compliance inspections by USDA-accredited certifying organization, Oregon Tilth.\nOrganic Product manufacturing\nWe start with the highest quality ingredients. After all, we’re only as good as the raw materials for our line of products. All Zatik Naturals ingredients are:\n\n● Vegan\n● Non-GMO\n● Gluten Free\n● Soy Free\n● Alcohol Free\n● Ph Balanced\n● Biodegradable\n● Certified Organic\nWe use food-safe manufacturing processes to create pure plant extracts without hazardous chemicals. We naturally distill plant extracts to capture their essential properties. Zatik Naturals uses CO2 extraction to efficiently produce high quality, ultra-concentrated extracts with precision.\n\nThe next step is to work in small, limited batches for every product. The right blend of natural ingredients are combined to maximize the healing, nourishing, and regenerative properties of our personal care products.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:22.402Z",
    importedBy: "entity-db-cli",
  },
};
